/* src/app/notify-templates/notify-templates.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.notify-templates {
  width: 100%;
  min-width: 21.5rem;
  max-width: 75rem;
  margin: 0 auto;
}
.notify-templates .page-actions {
  padding: 1em;
}
.notify-templates .templates {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
}
@media screen and (min-width: 48rem) {
  .notify-templates .templates {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
}
.notify-templates .templates .template-wrapper {
  max-width: 27em;
  width: 100%;
  padding: 1em;
}
@media screen and (min-width: 64rem) {
  .notify-templates .templates .template-wrapper {
    width: 24em;
  }
}
.notify-templates .templates .template-wrapper.create-template {
  position: relative;
  z-index: 1;
}
.notify-templates .templates .template-wrapper.create-template::before {
  content: "";
  position: absolute;
  top: 1rem;
  left: 1rem;
  width: 92%;
  height: 96.5%;
  border-radius: 5px;
  background-color: rgba(0, 0, 0, 0.64);
  transition: background-color 0.1s ease-in-out;
  z-index: 2;
}
.notify-templates .templates .template-wrapper.create-template::after {
  content: attr(data-content);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  text-align: center;
  color: white;
  text-transform: uppercase;
  font-size: 1.75em;
  transition: font-size 0.3s ease-in-out;
  z-index: 3;
}
.notify-templates .templates .template-wrapper.create-template:hover {
  cursor: pointer;
}
.notify-templates .templates .template-wrapper.create-template:hover::before {
  background-color: rgba(0, 0, 0, 0.85);
}
.notify-templates .templates .template-wrapper.create-template:hover::after {
  font-size: 2em;
}
/*# sourceMappingURL=notify-templates.component.css.map */
